/* unplugin-vue-components disabled */import script from "./message-input-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-button.vue?vue&type=script&setup=true&lang=ts"

import "./message-input-button.vue?vue&type=style&index=0&id=6952f27a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6952f27a"]])

export default __exports__